import { TailSpin } from "react-loader-spinner";
import Footer from "../../components/Footer";
import { generateYear, toggleMenu } from "../../utils/helpers";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { API_DOWNLOAD_ATTENDANCE, EMPLOYEE_LIST } from "../../config/Endpoints";
import { getApi } from "../../utils/api";
import Select, { components } from "react-select";
import PageTitle from "../../components/PageTitle";
import { employeeFlag } from "../../constants/employeeFlag";
import { employeeFlagOptions } from "../../options/employeFlagOptions";

const ExportAttendance = ({ title, description }) => {
  const [yearList] = useState(generateYear(2024));
  const accessToken = Cookies.get("accessToken");
  const [isLoading, setIsLoading] = useState();
  const [isCompileActive, setIsCompileActive] = useState(true);
  const [isCompile, setIsCompile] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds

  const initialState = {
    employeeId: "",
    month: new Date().toLocaleString("en-US", { month: "long" }),
    year: new Date().getFullYear(),
    employeeFlag: employeeFlag.ALL,
  };

  const [formData, setFormData] = useState(initialState);

  const [isFormValid, setIsFormValid] = useState(false);
  const employeeFlagSelectOptions = [
    { label: "All", value: "ALL" },
    ...employeeFlagOptions,
  ];
  const yearOptions = yearList.map((item) => ({
    label: item,
    value: item,
  }));

  const monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ].map((m) => ({ label: m, value: m }));

  useEffect(() => {
    fetchEmployeeList();
  }, [formData.employeeFlag]);

  useEffect(() => {
    if (isCompile) {
      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            setIsCompileActive(true);
            clearInterval(timerId);
            return 0; // Stop the timer
          }
          return prevTime - 1; // Decrease the time
        });
      }, 1000); // 1 second interval
      return () => {
        clearInterval(timerId);
      };
    }
  }, [isCompile]);

  const fetchEmployeeList = async () => {
    setIsLoading(true);
    let url = EMPLOYEE_LIST;

    if (
      !(
        formData.employeeFlag === "" ||
        formData.employeeFlag === employeeFlag.ALL
      )
    ) {
      url += "?type=" + formData.employeeFlag;
    }

    await getApi(url, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setEmployeeList(res.data.data);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });

    setFormData((prevFormData) => ({
      ...prevFormData,
      employeeId: initialState.employeeId,
    }));
    setSelectedEmployee(selectedEmployeeDefaultValue);
  };

  const formatTime = (timeLeft) => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);

      await fetch(
        `${API_DOWNLOAD_ATTENDANCE}?year=${formData.year}&month=${formData.month}&flag=${formData.employeeFlag}&employeeId=${formData.employeeId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/vnd.ms-excel",
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            toast.error("No record available to export");
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `Attendance_${formData.month}_${formData.year}.xlsx`;
          link.click();
          URL.revokeObjectURL(url);
          setIsLoading(false);
          handleReset();
        })
        .catch((error) => {
          setIsLoading(false);
          toast.error("Download failed");
        });
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const optionList = employeeList?.map((item) => ({
    value: item.id,
    label: item.empName,
    type: item.employeeType,
  }));

  const selectedEmployeeDefaultValue = {
    value: "",
    label: "All Employees",
    type: "",
  };

  optionList.unshift(selectedEmployeeDefaultValue);

  const validateForm = () => {
    return formData.employeeFlag !== "";
  };

  useEffect(() => {
    setIsFormValid(validateForm);
  }, [formData]);

  const Option = (props) => {
    const { data } = props;
    const { label, type } = data;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{label}</span>
          <span style={{ fontSize: "12px", color: "gray" }}>({type})</span>
        </div>
      </components.Option>
    );
  };
  const handleReset = () => {
    setFormData(initialState);
    setSelectedEmployee("");
  };

  return (
    <div className="wrapper-body">
      {(isLoading || isCompile) && (
        <div className="overlay">
          <div className="loader-container">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
      </div>
      <form id="assign-asset" onSubmit={handleSubmit}>
        <div className="card">
          {/* <h3 className="heading">Download Attendance</h3> */}
          <div className="inputs column-gap-2">
            <div className="row mt-4">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center">
                <label htmlFor="month" className="has-asterisk">
                  Month
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <div className="dropdown-container">
                    <Select
                      id="month"
                      classNamePrefix="rs"
                      options={monthOptions}
                      value={monthOptions.find(
                        (opt) => opt.value === formData.month
                      )}
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({
                          ...prev,
                          month: selectedOption.value,
                        }))
                      }
                      isSearchable={true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>

            <div className="row mt-1">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center ">
                <label htmlFor="year" className="has-asterisk">
                  Year
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <div className="dropdown-container">
                    <Select
                      id="year"
                      classNamePrefix="rs"
                      options={yearOptions}
                      value={yearOptions.find(
                        (opt) => opt.value === formData.year
                      )}
                      onChange={(selected) =>
                        setFormData((prev) => ({
                          ...prev,
                          year: selected.value,
                        }))
                      }
                      isSearchable={true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>

            <div className="row mt-1">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center">
                <label htmlFor="employee-flag" className="has-asterisk">
                  Employee Flag
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <div className="dropdown-container">
                    <Select
                      id="employee-flag"
                      classNamePrefix="rs"
                      options={employeeFlagSelectOptions}
                      value={employeeFlagSelectOptions.find(
                        (opt) => opt.value === formData.employeeFlag
                      )}
                      onChange={(selectedOption) => {
                        setFormData((prev) => ({
                          ...prev,
                          employeeFlag: selectedOption.value,
                        }));
                      }}
                      isSearchable={true}
                      placeholder="Select Employee Flag"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>

            <div className="row mt-1">
              <div className="col-md-2"></div>
              <div className="col-md-2 d-flex align-items-center ">
                <label
                  htmlFor="month"
                  // className="has-asterisk"
                >
                  Select Employee
                </label>
              </div>
              <div className="col-md-5">
                <div className="input-group">
                  <div className="dropdown-container">
                    <Select
                      options={optionList}
                      classNamePrefix="rs"
                      components={{ Option }}
                      onChange={(selectedOption) => {
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          employeeId: selectedOption.value,
                        }));
                        setSelectedEmployee(selectedOption);
                      }}
                      value={selectedEmployee || selectedEmployeeDefaultValue}
                      // placeholder="Choose"
                      isSearchable={true}
                      placeholder="Select Employee"

                      // required
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
          <br />

          <div className="action text-center">
            <button
              className="btn btn-secondary px-4 py-2"
              type="button"
              onClick={handleReset}
            >
              Reset
            </button>
            <button
              className={
                isLoading || !isFormValid
                  ? "theme-button disabled ms-2 "
                  : "theme-button ms-2 "
              }
              type="submit"
              disabled={!isFormValid}
              // disabled="true"
            >
              Download
            </button>
            {/* <button
              className={
                isDownLoading
                  ? "theme-button disabled ms-2 "
                  : "theme-button ms-2 "
              }
              type="submit"
              disabled={isDownLoading}
            >
              Download
            </button> */}
          </div>

          <div className="row">
            <h4 className="heading"></h4>
            <h4 className="heading">Instructions :</h4>
            <div className="col-md-10">
              <ul className="m-2">
                <li>
                  To download attendance, select the appropriate flag and
                  employee name using the "Employee Flag" feature.
                </li>
                <li>
                  For location-specific attendance of all employees, select the
                  corresponding flag from the same feature.
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              {/* {!isCompileActive && (
                <span className="">
                  <p
                    style={{ pointerEvents: "none" }}
                    className="text-white ms-1 fw-bolder fs-4 bg-success p-2 rounded text-center"
                  >
                    {formatTime(timeLeft)}
                  </p>
                </span>
              )} */}
            </div>
          </div>
        </div>
      </form>

      <Footer />
    </div>
  );
};

export default ExportAttendance;
